import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=33521752&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=33521752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33521752",
  null
  
)

export default component.exports